import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
	GetHealthEmergencyLink,
	GetHealthEmergencyLinkModel,
	GetHealthEmergencyLinkParams,
} from 'domain/usecases';

export class RemoteGetHealthEmergencyLink implements GetHealthEmergencyLink {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthEmergencyLinkModel>,
	) {}

	async get(params?: GetHealthEmergencyLinkParams): Promise<GetHealthEmergencyLinkModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
